// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Admin Dashboard ── */

/* 4-col stat grid */
.adb__stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

.adb__stat-card {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.adb__stat-top {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.adb__stat-icon-wrap {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.adb__stat-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--admin-muted);
  margin: 0;
  letter-spacing: 0.01em;
}

.adb__stat-value {
  font-family: var(--font-body);
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
  line-height: 1;
}

.adb__stat-change {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.78rem;
  font-weight: 500;
  margin: 0;
}
.adb__stat-change.up {
  color: var(--admin-green);
}
.adb__stat-change.down {
  color: var(--admin-red);
}

/* Main 2-col */
.adb__main-grid {
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 1rem;
  align-items: start;
}

/* Chart card */
.adb__chart-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.adb__chart-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.adb__chart-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
}

.adb__period-wrap {
  position: relative;
}
.adb__period-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  padding: 0.45rem 0.9rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--admin-text);
  cursor: pointer;
  transition: background 0.15s;
}
.adb__period-btn:hover {
  background: #faf7f2;
}

.adb__period-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  min-width: 140px;
  overflow: hidden;
  z-index: 50;
}
.adb__period-opt {
  display: block;
  width: 100%;
  padding: 0.55rem 0.9rem;
  text-align: left;
  background: none;
  border: none;
  font-size: 0.8rem;
  color: var(--admin-text);
  cursor: pointer;
  transition: background 0.15s;
}
.adb__period-opt:hover {
  background: #faf7f2;
}
.adb__period-opt.active {
  color: var(--admin-rust);
  font-weight: 700;
}

.adb__chart-wrap {
  width: 100%;
}
.adb__chart-svg {
  width: 100%;
  height: clamp(160px, 25vw, 240px);
  display: block;
}

/* App summary dots */
.adb__app-summary {
  display: flex;
  gap: clamp(1rem, 3vw, 2.5rem);
  flex-wrap: wrap;
  padding-top: 0.5rem;
  border-top: 1px solid var(--admin-border);
}

.adb__summary-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.adb__summary-dot {
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
}
.adb__summary-label {
  font-size: 0.78rem;
  color: var(--admin-muted);
  font-weight: 500;
}
.adb__summary-count {
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--admin-text);
}

/* Activity */
.adb__activity-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.adb__section-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
}

.adb__activity-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  max-height: 300px;
  overflow-y: auto;
}

.adb__activity-item {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.85rem 0;
  border-bottom: 1px solid var(--admin-border);
}
.adb__activity-item:last-child {
  border-bottom: none;
}

.adb__activity-icon {
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.88rem;
  flex-shrink: 0;
}

.adb__activity-text {
  flex: 1 1;
  font-size: 0.82rem;
  color: var(--admin-text);
  margin: 0;
  line-height: 1.4;
}
.adb__activity-text strong {
  font-weight: 700;
}

.adb__activity-time {
  font-size: 0.72rem;
  color: var(--admin-muted);
  white-space: nowrap;
  flex-shrink: 0;
}

.adb__view-all {
  width: 100%;
}

/* Bottom grid */
.adb__bottom-grid {
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 1rem;
  align-items: start;
}

/* Quick links */
.adb__quick-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.adb__quick-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
}

.adb__quick-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  text-decoration: none;
  transition:
    background 0.15s,
    box-shadow 0.15s;
  background: #fff;
}
.adb__quick-item:hover {
  background: #faf7f2;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.adb__quick-icon {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.adb__quick-text {
  flex: 1 1;
}
.adb__quick-label {
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0 0 0.15rem;
}
.adb__quick-sub {
  font-size: 0.7rem;
  color: var(--admin-muted);
  margin: 0;
  line-height: 1.35;
}

.adb__quick-arrow {
  font-size: 0.75rem;
  color: var(--admin-muted);
  flex-shrink: 0;
}

/* Help card */
.adb__help-body {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}
.adb__help-icon {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: rgba(124, 58, 237, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: #7c3aed;
  flex-shrink: 0;
}
.adb__help-text {
  font-size: 0.82rem;
  color: var(--admin-muted);
  margin: 0 0 1rem;
  line-height: 1.55;
}
.adb__help-btn {
  margin-top: 0;
}

/* Responsive */
@media (max-width: 1199px) {
  .adb__main-grid {
    grid-template-columns: 1fr;
  }
  .adb__bottom-grid {
    grid-template-columns: 1fr;
  }
  .adb__quick-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 767px) {
  .adb__stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .adb__quick-grid {
    grid-template-columns: 1fr;
  }
}

/* Chart tooltip */
.adb__tooltip {
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 8px;
  padding: 0.65rem 0.85rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.adb__tooltip-label {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0 0 0.35rem;
}
.adb__tooltip-val {
  font-size: 0.75rem;
  margin: 0.15rem 0 0;
}

/* ── V2.1: scope, clickable cards, needs attention, linked activity ── */
.adb__scope { display: flex; align-items: center; gap: 0.6rem; flex-wrap: wrap; margin-bottom: 1rem; font-size: 0.85rem; color: var(--admin-muted); }
.adb__scope select { font: inherit; font-size: 0.86rem; padding: 0.4rem 0.6rem; border: 1px solid var(--admin-border); border-radius: 8px; background: #fff; max-width: 100%; }
.adb__stat-card--link { text-decoration: none; color: inherit; display: block; transition: border-color 0.15s, box-shadow 0.15s; }
.adb__stat-card--link:hover { border-color: rgba(var(--admin-rust-rgb), 0.45); }
.adb__stat-card--link:focus-visible { outline: 2px solid var(--admin-rust); outline-offset: 2px; }
.adb__attention { margin-bottom: 1.25rem; }
.adb__attention:focus { outline: none; }
.adb__attention-none { display: flex; align-items: center; gap: 0.45rem; margin: 0; color: var(--admin-muted); font-size: 0.88rem; }
.adb__attention-none svg { color: var(--admin-green); font-size: 1.1rem; }
.adb__attention-list { list-style: none; margin: 0; padding: 0; display: grid; grid-template-columns: repeat(auto-fill, minmax(17rem, 1fr)); gap: 0.5rem; }
.adb__attention-item {
  display: flex; align-items: center; gap: 0.5rem; padding: 0.6rem 0.75rem; border-radius: 10px; text-decoration: none;
  color: var(--admin-text); font-size: 0.86rem; border: 1px solid var(--admin-border); background: #fff; min-height: 44px;
}
.adb__attention-item b { font-size: 1.05rem; font-variant-numeric: tabular-nums; }
.adb__attention-item span { flex: 1 1; }
.adb__attention-item svg:first-child { flex: none; }
.adb__attention-item--red svg:first-child { color: var(--admin-red); }
.adb__attention-item--amber svg:first-child { color: var(--admin-amber); }
.adb__attention-item--blue svg:first-child { color: var(--admin-blue); }
.adb__attention-item:hover { border-color: rgba(var(--admin-rust-rgb), 0.45); }
.adb__attention-item:focus-visible, .adb__activity-item--link:focus-visible { outline: 2px solid var(--admin-rust); outline-offset: 2px; }
.adb__activity-item--link { text-decoration: none; color: inherit; border-radius: 8px; }
.adb__activity-item--link:hover .adb__activity-text { color: var(--admin-rust); }
.adb__activity-who { color: var(--admin-muted); font-weight: 400; }
.adb__main-grid--single { grid-template-columns: 1fr; }
.adb__attention .adb__section-title { margin-bottom: 0.75rem; }
`, "",{"version":3,"sources":["webpack://./src/admin/AdminDashboard.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,iCAAiC;EACjC,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB;;oBAEkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE,cAAc,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,eAAe,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;AACpJ,qBAAqB,aAAa,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,qCAAqC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC9K,wBAAwB,qBAAqB,EAAE,cAAc,EAAE,cAAc,EAAE,gDAAgD,EAAE;AACjI,8BAA8B,+CAA+C,EAAE;AAC/E,sCAAsC,oCAAoC,EAAE,mBAAmB,EAAE;AACjG,kBAAkB,sBAAsB,EAAE;AAC1C,wBAAwB,aAAa,EAAE;AACvC,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE,SAAS,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;AACnI,2BAA2B,yBAAyB,EAAE,iBAAiB,EAAE;AACzE,uBAAuB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,aAAa,EAAE,4DAA4D,EAAE,WAAW,EAAE;AAC1J;EACE,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,qBAAqB;EACpH,wBAAwB,EAAE,kBAAkB,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,gBAAgB;AACzH;AACA,yBAAyB,kBAAkB,EAAE,kCAAkC,EAAE;AACjF,4BAA4B,SAAO,EAAE;AACrC,uCAAuC,UAAU,EAAE;AACnD,4CAA4C,uBAAuB,EAAE;AACrE,8CAA8C,yBAAyB,EAAE;AACzE,6CAA6C,wBAAwB,EAAE;AACvE,6BAA6B,+CAA+C,EAAE;AAC9E,8EAA8E,oCAAoC,EAAE,mBAAmB,EAAE;AACzI,4BAA4B,qBAAqB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACvF,sDAAsD,wBAAwB,EAAE;AAChF,qBAAqB,yBAAyB,EAAE,gBAAgB,EAAE;AAClE,0BAA0B,0BAA0B,EAAE;AACtD,sCAAsC,sBAAsB,EAAE","sourcesContent":["/* ── Admin Dashboard ── */\n\n/* 4-col stat grid */\n.adb__stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n}\n\n.adb__stat-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.adb__stat-top {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.adb__stat-icon-wrap {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.adb__stat-label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--admin-muted);\n  margin: 0;\n  letter-spacing: 0.01em;\n}\n\n.adb__stat-value {\n  font-family: var(--font-body);\n  font-size: clamp(1.6rem, 3vw, 2.2rem);\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n  line-height: 1;\n}\n\n.adb__stat-change {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.78rem;\n  font-weight: 500;\n  margin: 0;\n}\n.adb__stat-change.up {\n  color: var(--admin-green);\n}\n.adb__stat-change.down {\n  color: var(--admin-red);\n}\n\n/* Main 2-col */\n.adb__main-grid {\n  display: grid;\n  grid-template-columns: 1fr 360px;\n  gap: 1rem;\n  align-items: start;\n}\n\n/* Chart card */\n.adb__chart-card {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.adb__chart-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.adb__chart-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n}\n\n.adb__period-wrap {\n  position: relative;\n}\n.adb__period-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  padding: 0.45rem 0.9rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--admin-text);\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.adb__period-btn:hover {\n  background: #faf7f2;\n}\n\n.adb__period-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n  min-width: 140px;\n  overflow: hidden;\n  z-index: 50;\n}\n.adb__period-opt {\n  display: block;\n  width: 100%;\n  padding: 0.55rem 0.9rem;\n  text-align: left;\n  background: none;\n  border: none;\n  font-size: 0.8rem;\n  color: var(--admin-text);\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.adb__period-opt:hover {\n  background: #faf7f2;\n}\n.adb__period-opt.active {\n  color: var(--admin-rust);\n  font-weight: 700;\n}\n\n.adb__chart-wrap {\n  width: 100%;\n}\n.adb__chart-svg {\n  width: 100%;\n  height: clamp(160px, 25vw, 240px);\n  display: block;\n}\n\n/* App summary dots */\n.adb__app-summary {\n  display: flex;\n  gap: clamp(1rem, 3vw, 2.5rem);\n  flex-wrap: wrap;\n  padding-top: 0.5rem;\n  border-top: 1px solid var(--admin-border);\n}\n\n.adb__summary-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n.adb__summary-dot {\n  width: 0.6rem;\n  height: 0.6rem;\n  border-radius: 50%;\n}\n.adb__summary-label {\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n  font-weight: 500;\n}\n.adb__summary-count {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: var(--admin-text);\n}\n\n/* Activity */\n.adb__activity-card {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.adb__section-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n}\n\n.adb__activity-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.adb__activity-item {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 0.85rem 0;\n  border-bottom: 1px solid var(--admin-border);\n}\n.adb__activity-item:last-child {\n  border-bottom: none;\n}\n\n.adb__activity-icon {\n  width: 2.1rem;\n  height: 2.1rem;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.88rem;\n  flex-shrink: 0;\n}\n\n.adb__activity-text {\n  flex: 1;\n  font-size: 0.82rem;\n  color: var(--admin-text);\n  margin: 0;\n  line-height: 1.4;\n}\n.adb__activity-text strong {\n  font-weight: 700;\n}\n\n.adb__activity-time {\n  font-size: 0.72rem;\n  color: var(--admin-muted);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.adb__view-all {\n  width: 100%;\n}\n\n/* Bottom grid */\n.adb__bottom-grid {\n  display: grid;\n  grid-template-columns: 1fr 360px;\n  gap: 1rem;\n  align-items: start;\n}\n\n/* Quick links */\n.adb__quick-card {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n.adb__quick-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.75rem;\n}\n\n.adb__quick-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  text-decoration: none;\n  transition:\n    background 0.15s,\n    box-shadow 0.15s;\n  background: #fff;\n}\n.adb__quick-item:hover {\n  background: #faf7f2;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.adb__quick-icon {\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.adb__quick-text {\n  flex: 1;\n}\n.adb__quick-label {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0 0 0.15rem;\n}\n.adb__quick-sub {\n  font-size: 0.7rem;\n  color: var(--admin-muted);\n  margin: 0;\n  line-height: 1.35;\n}\n\n.adb__quick-arrow {\n  font-size: 0.75rem;\n  color: var(--admin-muted);\n  flex-shrink: 0;\n}\n\n/* Help card */\n.adb__help-body {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n}\n.adb__help-icon {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  background: rgba(124, 58, 237, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  color: #7c3aed;\n  flex-shrink: 0;\n}\n.adb__help-text {\n  font-size: 0.82rem;\n  color: var(--admin-muted);\n  margin: 0 0 1rem;\n  line-height: 1.55;\n}\n.adb__help-btn {\n  margin-top: 0;\n}\n\n/* Responsive */\n@media (max-width: 1199px) {\n  .adb__main-grid {\n    grid-template-columns: 1fr;\n  }\n  .adb__bottom-grid {\n    grid-template-columns: 1fr;\n  }\n  .adb__quick-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@media (max-width: 767px) {\n  .adb__stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .adb__quick-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Chart tooltip */\n.adb__tooltip {\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 8px;\n  padding: 0.65rem 0.85rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n.adb__tooltip-label {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0 0 0.35rem;\n}\n.adb__tooltip-val {\n  font-size: 0.75rem;\n  margin: 0.15rem 0 0;\n}\n\n/* ── V2.1: scope, clickable cards, needs attention, linked activity ── */\n.adb__scope { display: flex; align-items: center; gap: 0.6rem; flex-wrap: wrap; margin-bottom: 1rem; font-size: 0.85rem; color: var(--admin-muted); }\n.adb__scope select { font: inherit; font-size: 0.86rem; padding: 0.4rem 0.6rem; border: 1px solid var(--admin-border); border-radius: 8px; background: #fff; max-width: 100%; }\n.adb__stat-card--link { text-decoration: none; color: inherit; display: block; transition: border-color 0.15s, box-shadow 0.15s; }\n.adb__stat-card--link:hover { border-color: rgba(var(--admin-rust-rgb), 0.45); }\n.adb__stat-card--link:focus-visible { outline: 2px solid var(--admin-rust); outline-offset: 2px; }\n.adb__attention { margin-bottom: 1.25rem; }\n.adb__attention:focus { outline: none; }\n.adb__attention-none { display: flex; align-items: center; gap: 0.45rem; margin: 0; color: var(--admin-muted); font-size: 0.88rem; }\n.adb__attention-none svg { color: var(--admin-green); font-size: 1.1rem; }\n.adb__attention-list { list-style: none; margin: 0; padding: 0; display: grid; grid-template-columns: repeat(auto-fill, minmax(17rem, 1fr)); gap: 0.5rem; }\n.adb__attention-item {\n  display: flex; align-items: center; gap: 0.5rem; padding: 0.6rem 0.75rem; border-radius: 10px; text-decoration: none;\n  color: var(--admin-text); font-size: 0.86rem; border: 1px solid var(--admin-border); background: #fff; min-height: 44px;\n}\n.adb__attention-item b { font-size: 1.05rem; font-variant-numeric: tabular-nums; }\n.adb__attention-item span { flex: 1; }\n.adb__attention-item svg:first-child { flex: none; }\n.adb__attention-item--red svg:first-child { color: var(--admin-red); }\n.adb__attention-item--amber svg:first-child { color: var(--admin-amber); }\n.adb__attention-item--blue svg:first-child { color: var(--admin-blue); }\n.adb__attention-item:hover { border-color: rgba(var(--admin-rust-rgb), 0.45); }\n.adb__attention-item:focus-visible, .adb__activity-item--link:focus-visible { outline: 2px solid var(--admin-rust); outline-offset: 2px; }\n.adb__activity-item--link { text-decoration: none; color: inherit; border-radius: 8px; }\n.adb__activity-item--link:hover .adb__activity-text { color: var(--admin-rust); }\n.adb__activity-who { color: var(--admin-muted); font-weight: 400; }\n.adb__main-grid--single { grid-template-columns: 1fr; }\n.adb__attention .adb__section-title { margin-bottom: 0.75rem; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
